import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/MyProcess.css';
import '../styles/Hero.css'
import Ticker from './Ticker';


function MyProcess() {
 return(
  <div className="my-process-container">
    <section className="hero py-5">
      <div className="container">
        <h1 className="portfolio-title display-3 col-md-6">Where UX Design Meets Front-End Engineering</h1>
        <p className="portfolio-intro lead col-lg-10 col-md-12 col-sm-12">
          My process is grounded in hands-on implementation. I design and write front-end code myself, using production constraints to inform UX decisions from the start. By moving directly from concept to code, I validate ideas early, reduce handoff friction, and deliver solutions that are scalable, maintainable, and ready to ship.
        </p>
      </div>
    </section>
    <Ticker text="my process" />
    <div className="row mt-4">
      <h2 className="col-md-6">1. Problem Framing & Technical Context</h2>
      <p>I start by understanding both the user problem and the system it lives in. This includes clarifying goals, constraints, success metrics, and reviewing existing architecture, APIs, and design systems. Grounding early decisions in technical reality helps avoid rework later and sets a clear direction for what’s feasible.  </p>
    </div>
    <div className="row mt-4">
      <h2 className="col-md-6">2. Early Modeling in Code</h2>
      <p>Before high-fidelity visuals, I often prototype directly in code. Lightweight components, layout scaffolding, or interaction spikes help me validate structure, behavior, and edge cases early. Code becomes a thinking tool—not just an output—allowing me to test assumptions faster than static mockups.</p>
    </div>
    <div className="row mt-4">
      <h2 className="col-md-6">3. UX & Interaction Design</h2>
      <p>With constraints clearly defined, I refine user flows, interaction patterns, and information hierarchy. I focus on clarity, accessibility, and system consistency—designing experiences that are intuitive for users and predictable for engineers. At this stage, visuals serve structure, not the other way around.</p>
    </div>
    <div className="row mt-4">
      <h2 className="col-md-6">4. Production Implementation</h2>
      <p>I implement the design myself, writing front-end code that aligns with existing systems and design standards. This includes building reusable components, handling states and errors, and ensuring performance and accessibility are accounted for. Designing and building in parallel allows me to resolve issues in real time rather than at handoff.</p>
    </div>
    <div className="row mt-4">
      <h2 className="col-md-6">5. Validation & Iteration</h2>
      <p>Once in code, I test assumptions through real usage—QA, stakeholder review, and user feedback where possible. I iterate directly in the implementation layer, refining interactions, tightening logic, and improving clarity based on what actually works in practice.</p>
    </div>
    <div className="row mt-4">
      <h2 className="col-md-6">6. Systemization & Documentation</h2>
      <p>After shipping, I look for opportunities to generalize patterns into reusable components or guidelines. I document decisions, update design systems, and share learnings with the team to reduce future friction and improve consistency across products.</p>
    </div>
  </div>
  
 )
}

export default MyProcess;
